<template>
  <div class="app">
    <Card dis-hover>
      <div class="page-body">
        <Form ref="queryForm" :label-width="90" label-position="right" inline>
          <!-- <Row :gutter="18">
            <Col span="4"> -->
          <FormItem label="记录编号:">
            <Input v-model="query.record" style="width: 180px" placeholder="请输入记录编号"></Input>
          </FormItem>
          <!-- </Col>
            <Col span="4"> -->
          <FormItem label="物料名称:">
            <Input v-model="query.material" style="width: 180px" placeholder="请输入物料名称"></Input>
          </FormItem>
          <!-- </Col>
            <Col span="4"> -->
          <FormItem label="责任部门:">
            <Input v-model="query.accountabilityUnit" style="width: 180px" placeholder="请输入责任部门"></Input>
          </FormItem>
          <!-- </Col>
            <Col span="4"> -->
          <FormItem label="责任人:">
            <Input v-model="query.accountabilityUser" style="width: 180px" placeholder="请输入责任人"></Input>
          </FormItem>
          <!-- </Col>
            <Col span="4"> -->
          <FormItem prop="rangeTime" label="发生时间:">
            <DatePicker v-model="query.rangeTime" type="daterange" format="yyyy-MM-dd" style="width: 180px" placement="bottom-end" placeholder="请选择发生时间"></DatePicker>
          </FormItem>
          <!-- </Col>
            <Col span="4"> -->
          <FormItem label="不合格品类型:">
            <Select v-model="query.type" style="width: 180px" placeholder="请选择类型">
              <Option value=" ">------</Option>
              <Option v-for="(item, index) in productTypeList" :key="index" :value="item.value">
                {{ item.name }}
              </Option>
            </Select>
          </FormItem>
          <!-- </Col>
            <Col span="4"> -->
          <FormItem label="状态:">
            <Select v-model="query.status" style="width: 180px" placeholder="请选择状态">
              <Option value=" ">------</Option>
              <Option v-for="item in statusList" :key="item.value" :value="item.value">
                {{ item.name }}
              </Option>
            </Select>
          </FormItem>
          <!-- </Col> -->
          <!-- <Col span="4"> -->
          <FormItem :label-width="0">
            <Button icon="ios-search" type="primary" size="default" @click="getpage(1)" class="toolbar-btn">{{ '查询' }}</Button>
            <Button @click="exportFile" icon="md-archive" type="primary" size="default" class="toolbar-btn">{{ '导出' }}</Button>
          </FormItem>
          <!-- </Col>
            <Col span="5"> -->
          <FormItem :label-width="0">
            <Button icon="md-archive" type="primary" size="default" @click="exportOrderStatus" class="toolbar-btn">导出状态统计</Button>
          </FormItem>
          <!-- </Col>
          </Row> -->
        </Form>
        <div v-if="list">
          <Table :loading="loading" :columns="columns" no-data-text="暂无数据" border :data="list"></Table>
          <Page show-total show-sizer class-name="fengpage" :total="totalCount" class="margin-top-10" @on-change="pageChange" @on-page-size-change="pagesizeChange" :page-size="pageSize" :current="currentPage"></Page>
        </div>
      </div>
    </Card>
    <Detail v-model="detailModalShow" :infoData="info" v-if="isGetData" @loadingChange="loadingChange" @succesConfirm="closeModal" @save-success="getpage" />
    <Print v-model="printModalShow" v-if="isShowPrint" :infoData="info" @succesConfirm="closePrintModal" />
    <Modal v-model="isShowDel" @on-ok="del" @on-cancel="isShowDel = false" class="modal-cont" ok-text="确认">确认删除该不合格处理单吗？</Modal>
    <Spin fix v-show="gLoading">
      <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
      <div>加载中</div>
    </Spin>
  </div>
</template>

<script>
import Detail from './detail.vue'
import Print from './print.vue'
import Util from '../../lib/util'
export default {
  name: 'unacceptedProductProcessOrder',
  data() {
    return {
      query: {
        record: '',
        material: '',
        type: null,
        rangeTime: '',
        status: null,
        accountabilityUser: '',
        accountabilityUnit: '',
      },
      list: [],
      productTypeList: [],
      statusList: [],
      info: null,
      isGetData: false,
      pageSize: 10,
      currentPage: 1,
      totalCount: 0,
      loading: false,
      detailModalShow: false,
      columns: [],
      printModalShow: false,
      isShowPrint: false,
      gLoading: false,
      isShowDel: false,
    }
  },
  components: {
    Detail,
    Print,
  },
  methods: {
    exportFile() {
      var _this = this
      if (!this.query.record) {
        this.query.record = ''
      }
      if (!this.query.material) {
        this.query.material = ''
      }
      if (!this.query.type) {
        this.query.type = ''
      }
      if (!this.query.status) {
        this.query.status = ''
      }
      let OccurrenceTimeStart
      let OccurrenceTimeEnd
      if (this.query.rangeTime[0]) {
        OccurrenceTimeStart = this.formatDate(this.query.rangeTime[0])
        OccurrenceTimeEnd = this.formatDate(this.query.rangeTime[1])
      } else {
        OccurrenceTimeStart = ''
        OccurrenceTimeEnd = ''
      }
      // console.log(Util.abp.auth.getToken())
      const date = this.$moment(new Date()).format('yyyyMMDDHHmm')
      let consturl = `${this.$constDefinition.baseUrl}/api/Export/ExportUnacceptedProductProcessOrders?RecordNumber=${this.query.record}&MaterialName=${this.query.material}&ProductType=${this.query.type}&Status=${this.query.status}&OccurrenceTimeStart=${OccurrenceTimeStart}&OccurrenceTimeEnd=${OccurrenceTimeEnd}&AccountabilityUser=${this.query.accountabilityUser}&AccountabilityUnit=${this.query.accountabilityUnit}` //下载地址url
      var xhr = new XMLHttpRequest()
      xhr.open('get', consturl, true) // get、post都可
      xhr.responseType = 'blob'
      xhr.setRequestHeader('Authorization', `Bearer ${Util.abp.auth.getToken()}`) //加请求头
      xhr.onload = function () {
        if (xhr.status == 200) {
          let blob = new Blob([this.response], {
            type: 'application/vnd.ms-excel',
          })
          var a = document.createElement('a')
          var url = window.URL.createObjectURL(blob)
          a.href = url
          a.download = `不合格品异常统计表${date}.xlsx` // 文件名
          if (xhr.readyState === 4) {
            _this.$Message.success({
              content: '下载成功',
            })
          }
        } else {
          _this.$Message.error({
            content: '下载失败',
          })
        }
        a.click()
        window.URL.revokeObjectURL(url)
      }
      xhr.send()
    },
    exportOrderStatus() {
      var _this = this
      if (!this.query.record) {
        this.query.record = ''
      }
      if (!this.query.material) {
        this.query.material = ''
      }
      if (!this.query.type) {
        this.query.type = ''
      }
      if (!this.query.status) {
        this.query.status = ''
      }
      let OccurrenceTimeStart
      let OccurrenceTimeEnd
      if (this.query.rangeTime[0]) {
        OccurrenceTimeStart = this.formatDate(this.query.rangeTime[0])
        OccurrenceTimeEnd = this.formatDate(this.query.rangeTime[1])
      } else {
        OccurrenceTimeStart = ''
        OccurrenceTimeEnd = ''
      }
      const date = this.$moment(new Date()).format('yyyyMMDDHHmm')
      let consturl = `${this.$constDefinition.baseUrl}/api/Export/ExportOrderStatus?RecordNumber=${this.query.record}&MaterialName=${this.query.material}&ProductType=${this.query.type}&Status=${this.query.status}&OccurrenceTimeStart=${OccurrenceTimeStart}&OccurrenceTimeEnd=${OccurrenceTimeEnd}&AccountabilityUser=${this.query.accountabilityUser}&AccountabilityUnit=${this.query.accountabilityUnit}` //下载地址url
      var xhr = new XMLHttpRequest()
      xhr.open('get', consturl, true) // get、post都可
      xhr.responseType = 'blob'
      xhr.setRequestHeader('Authorization', `Bearer ${Util.abp.auth.getToken()}`) //加请求头
      xhr.onload = function () {
        if (xhr.status == 200) {
          let blob = new Blob([this.response], {
            type: 'application/vnd.ms-excel',
          })
          var a = document.createElement('a')
          var url = window.URL.createObjectURL(blob)
          a.href = url
          a.download = `处理单状态统计${date}.xlsx` // 文件名
          if (xhr.readyState === 4) {
            _this.$Message.success({
              content: '下载成功',
            })
          }
        } else {
          _this.$Message.error({
            content: '下载失败',
          })
        }
        a.click()
        window.URL.revokeObjectURL(url)
      }
      xhr.send()
    },
    async getInit() {
      const data = await this.$Ajax(
        '/api/services/app/UnacceptedProductProcessOrder/GetMgrInitData'
      )
      this.productTypeList = data.data.result.productTypeList
      this.statusList = data.data.result.statusList
      this.getpage()
    },
    async getpage(params) {
      // SkipCount 跳过多少条数据
      // MaxResultCount 每次最多返回多少条
      if (params == 1) {
        this.currentPage = 1
      }
      let str = `/api/services/app/UnacceptedProductProcessOrder/QueryDto?IncludeSelectItem=true&MaxResultCount=${
        this.pageSize
      }&SkipCount=${(this.currentPage - 1) * this.pageSize}&AccountabilityUser=${
        this.query.accountabilityUser
      }&AccountabilityUnit=${this.query.accountabilityUnit}`
      if (this.query.record) {
        str += `&RecordNumber=${this.query.record}`
      }
      if (this.query.material) {
        str += `&MaterialName=${this.query.material}`
      }
      if (this.query.type) {
        str += `&ProductType=${this.query.type}`
      }
      if (this.query.status) {
        str += `&Status=${this.query.status}`
      }
      if (this.query.rangeTime[0]) {
        let OccurrenceTimeStart = this.formatDate(this.query.rangeTime[0])
        let OccurrenceTimeEnd = this.formatDate(this.query.rangeTime[1])
        str += `&OccurrenceTimeStart=${OccurrenceTimeStart}&OccurrenceTimeEnd=${OccurrenceTimeEnd}`
      }
      this.loading = true
      const data = await this.$Ajax.get(str)
      this.list = data.data.result.items
      this.totalCount = data.data.result.totalCount
      this.loading = false
    },
    formatDate(datetime) {
      let date = new Date(datetime)
      let y = date.getFullYear()
      let m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      let d = date.getDate()
      d = d < 10 ? '0' + d : d
      return y + '-' + m + '-' + d
    },
    pageChange(page) {
      this.currentPage = page
      this.getpage()
      //重新渲染页面
    },
    pagesizeChange(pagesize) {
      this.pageSize = pagesize
      this.getpage()
      //重新渲染页面
    },
    closeModal(value) {
      this.detailModalShow = value
      this.isGetData = false
    },
    closePrintModal() {
      this.printModalShow = true
      this.isShowPrint = false
    },
    loadingChange() {
      this.gLoading = !this.gLoading
    },
    getColumns() {
      let _this = this
      this.columns = [
        {
          title: '记录编号',
          key: 'recordNumber',
          width: 144,
        },
        {
          title: '类型',
          key: 'productType_Text',
          width: 100,
        },
        {
          title: '物料名称',
          key: 'materialName',
          width: 120,
        },
        {
          title: '图号/物料编码',
          key: 'materialCode',
          minWidth: 140,
        },
        {
          title: '责任单位/部门',
          key: 'accountabilityUnit',
          minWidth: 80,
          maxWidth: 120,
        },
        {
          title: '责任人',
          key: 'accountabilityUser',
          width: 90,
        },
        {
          title: '不良类别',
          key: 'undesirableCategoryText',
          width: 90,
          // render:(h,params) => {
          //     return h("span", params.row.selectItem.name)
          // }
        },
        {
          title: '填写人',
          key: 'writtenUser',
          width: 90,
        },
        {
          title: '发生时间',
          key: 'occurrenceTimeText',
          width: 140,
        },
        {
          title: '提交时间',
          key: 'submitText',
          width: 140,
        },
        {
          title: '完成时间',
          key: 'finishTimeText',
          width: 140,
        },
        {
          title: '状态',
          key: 'statusText',
          minWidth: 110,
        },
        {
          title: '操作',
          align: 'center',
          width: 180,
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  on: {
                    click: () => {
                      _this.info = params.row.id
                      _this.isGetData = true //控制数据传输给detail组件
                      // console.log('row',params.row)//打印出来就是初始结果
                      _this.detailModalShow = true
                    },
                  },
                },
                params.row.status == _this.$constDefinition.completed ? '详情' : '操作'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  style: {
                    marginLeft: '5px',
                  },
                  on: {
                    click: () => {
                      _this.info = params.row.id
                      _this.isShowPrint = true //控制数据传输给detail组件
                      _this.printModalShow = true
                    },
                  },
                },
                '打印'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'error',
                    size: 'small',
                  },
                  style: {
                    display: params.row.isShow_删除 ? '' : 'none',
                    marginLeft: '5px',
                  },
                  on: {
                    click: () => {
                      this.info = params.row.id
                      this.isShowDel = true
                    },
                  },
                },
                '删除'
              ),
            ])
          },
        },
      ]
    },
    async del() {
      this.isShowDel = false
      try {
        const res = await this.$Ajax.delete(
          `/api/services/app/UnacceptedProductProcessOrder/Delete?Id=${this.info}`
        )
        this.$Message.success('删除成功')
      } catch (err) {
        if (err) {
          this.$Message.error('删除成功')
        }
      }
      this.getpage()
    },
  },
  mounted() {
    this.query.record = this.$route.query.workName
    this.getInit()
    this.getColumns()
  },
}
</script>

<style lang="less" scoped>
.app {
  min-width: 1260px;
}
.modal-cont /deep/ .ivu-modal-body {
  font-size: 20px;
  text-align: center;
}
.modal-cont /deep/ .ivu-modal {
  top: 300px;
}
/deep/.ivu-modal-footer {
  text-align: center;
}
</style>
